module.exports = __webpack_public_path__ + "img/icon_03.67f07f30.svg";